const STAFF_SESSION_STORAGE_KEY = 'ldsurveyStaff';

export function getStoredStaffSession() {
  try {
    const raw = localStorage.getItem(STAFF_SESSION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.staff) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveStaffSession(session) {
  localStorage.setItem(STAFF_SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function clearStaffSession() {
  localStorage.removeItem(STAFF_SESSION_STORAGE_KEY);
}

export function authHeaders() {
  const session = getStoredStaffSession();
  if (!session?.token) return {};
  return { Authorization: `Bearer ${session.token}` };
}
